<template>
  <div class="diagram-container">
    <DiagramBuilder
      ref="diagramBuilder"
      v-if="currentTask"
      :taskProp="currentTask"
      :show-toolbar="showToolbar"
      :show-list="showList"
      :tool="tool"
      :read-only="readOnly"
      @zoomChange="onZoomChange"
    />
  </div>
</template>

<script>
import debounce from 'lodash/debounce';

import DiagramBuilder from '../DiagramBuilder/DiagramBuilder';
import BubbleDTO from '../../shared/dtos/BubbleDTO';

import { SAVE_BUBBLES } from '../../store/bubbles/actions/actionTypes';
import { GET_TASK_BUBBLES } from '../../store/bubbles/getters/getterTypes';
import { GET_CURRENT_TASK } from '../../store/tasks/getters/getterTypes';

export default {
  components: { DiagramBuilder },
  props: {
    showToolbar: {
      type: Boolean,
      required: true,
    },
    showList: {
      type: Boolean,
      required: true,
    },
    tool: {
      type: String,
      required: false,
      default: '',
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      currentTask: null,
    };
  },
  computed: {
    task() {
      return this.$store.getters[GET_CURRENT_TASK];
    },
    taskBubbles() {
      return this.$store.getters[GET_TASK_BUBBLES];
    },
  },
  mounted() {
    // Reason why copying the task is that once send
    // to Diagram builder we need to set all the information beforehand
    this.currentTask = this.task;
    this.currentTask.diagram = this.task.diagram || {};
    this.currentTask.diagram.annotations = [];
    this.currentTask.diagram.inspections = [];

    if (this.taskBubbles) {
      this.taskBubbles.forEach((bubble) => {
        if (['text', 'arrow', 'line', 'link'].includes(bubble.type)) {
          this.currentTask.diagram.annotations.push(bubble);
        } else {
          this.currentTask.diagram.inspections.push(bubble);
        }
      });
    }
  },
  methods: {
    onAccuScanImport(data) {
      this.$refs.diagramBuilder.importAccuScanValues(data);
    },
    onLaserScanImport(data) {
      this.$refs.diagramBuilder.importLaserScanValues(data);
    },
    getInspections() {
      return this.$refs.diagramBuilder.inspections || [];
    },
    async onSave() {
      const bubbles = this.taskBubbles.map(
        (inspection) =>
          new BubbleDTO({
            _id: inspection.id,
            ...inspection,
          })
      );

      if (bubbles.length > 0) {
        await this.$store.dispatch(SAVE_BUBBLES, {
          taskId: this.currentTask._id,
          data: bubbles,
        });
      }
    },
    onZoomChange: debounce(function (zoomLevel) {
      const updatedTask = { ...this.task };
      updatedTask.zoomLevel = zoomLevel;

      // Too clean up old
      if (updatedTask.lengthData) delete updatedTask.lengthData;
      if (updatedTask.diameterData) delete updatedTask.diameterData;
      if (updatedTask.runoutData) delete updatedTask.runoutData;
      if (updatedTask.visualData) delete updatedTask.visualData;
      if (updatedTask.genericData) delete updatedTask.genericData;
      if (updatedTask.attachmentData) delete updatedTask.attachmentData;

      this.$store.dispatch('updateTask', updatedTask);
    }, 500),
  },
};
</script>

<style scoped>
.diagram-container {
  height: calc(100vh - 100px);
}
</style>
